// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3Ku-9","validationTips":"StatementDescriptor_validationTips__2vc79"};